import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { DELETE_ADDRESS_DATA_PROTECTION_LINK, GET_ADDRESS_DATA_PROTECTION_LINK, GET_ADDRESS_DATA_PROTECTION_LINK_BY_ADDRESS_ID, GET_ADDRESS_DATA_PROTECTION_LINKS, SAVE_ADDRESS_DATA_PROTECTION_LINK } from "../../../data/definitions/data-protection.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { AddressDataProtectionLink, AddressDataProtectionLinkInput, DeleteAddressDataProtectionLinkMutation, DeleteAddressDataProtectionLinkMutationVariables, DeletionResponse, GetAddressDataProtectionLinkByAddressIdQuery, GetAddressDataProtectionLinkByAddressIdQueryVariables, GetAddressDataProtectionLinkQuery, GetAddressDataProtectionLinkQueryVariables, GetAddressDataProtectionLinksQuery, GetAddressDataProtectionLinksQueryVariables, SaveAddressDataProtectionLinkMutation, SaveAddressDataProtectionLinkMutationVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
  providedIn: 'root'
})
export class AddressDataProtectionLinkService extends BaseListService<AddressDataProtectionLink> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_ADDRESS_DATA_PROTECTION_LINKS;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetAddressDataProtectionLinksQuery, GetAddressDataProtectionLinksQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetAddressDataProtectionLinkQuery, GetAddressDataProtectionLinkQueryVariables>(
      GET_ADDRESS_DATA_PROTECTION_LINK, {
      id: id
    });
  }

  getItemByAddressId(addressId: string) {
    return this.baseDataService.query<GetAddressDataProtectionLinkByAddressIdQuery, GetAddressDataProtectionLinkByAddressIdQueryVariables>(
      GET_ADDRESS_DATA_PROTECTION_LINK_BY_ADDRESS_ID, {
      addressId: addressId
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getAddressDataProtectionLink);
  }

  async getItemData(id: string): Promise<AddressDataProtectionLink> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getAddressDataProtectionLink as AddressDataProtectionLink;
  }

  async getItemDataByAddressId(addressId: string): Promise<AddressDataProtectionLink> {
    let l = await lastValueFrom(this.getItemByAddressId(addressId).single$);
    return l.getAddressDataProtectionLinkByAddressId as AddressDataProtectionLink;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {
    let res = await lastValueFrom(this.baseDataService.mutate<DeleteAddressDataProtectionLinkMutation, DeleteAddressDataProtectionLinkMutationVariables>(
      DELETE_ADDRESS_DATA_PROTECTION_LINK, {
      id: id
    }));

    return res.deleteAddressDataProtectionLink
  }

  async saveItem(item: AddressDataProtectionLink | AddressDataProtectionLinkInput) {

    let validated = await this.systemService.validateObject<AddressDataProtectionLinkInput>(
      item, "AddressDataProtectionLinkInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveAddressDataProtectionLinkMutation, SaveAddressDataProtectionLinkMutationVariables>(
      SAVE_ADDRESS_DATA_PROTECTION_LINK, {
      input: validated
    }));

    return saved.saveAddressDataProtectionLink as AddressDataProtectionLink;
  }
  //#endregion

}
